var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSToolLinePen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconS-tool-line-pen",
    x: 0,
    y: 0,
    width: 39.992,
    height: 23.998,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconS-tool-line-pen1",
    serifid: "iconS-tool-line-pen"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.022,3.653c0.887,-0.887 2.327,-0.887 3.214,0l1.232,1.234c0.887,0.887 0.887,2.326 0,3.213l-1.717,1.717l-4.447,-4.447l1.718,-1.717Zm1.927,6.966l-8.274,8.271c-0.369,0.369 -0.827,0.642 -1.327,0.787l-4.27,1.256c-0.298,0.089 -0.515,0.087 -0.735,-0.139c-0.193,-0.198 -0.244,-0.451 -0.156,-0.753l1.256,-4.268c0.148,-0.501 0.418,-0.958 0.788,-1.327l8.272,-8.273l4.446,4.446Zm-16.368,9.994c-0.207,0.358 -0.666,0.481 -1.024,0.274l-17.323,-10.001c-0.358,-0.207 -0.481,-0.666 -0.274,-1.024c0.206,-0.359 0.666,-0.482 1.024,-0.275l17.323,10.001c0.358,0.207 0.481,0.666 0.274,1.025Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSToolLinePen);
export default __webpack_public_path__ + "static/media/iconS-tool-line-pen.1137f265956b7b525027ec1aa9932017.svg";
export { ForwardRef as ReactComponent };